export const getRetentionFeatureName = () => 'Insights';
export const getRetentionFeatureMenuName = () => 'Insights';
